import { ChevronsLeftRight, Minus, X } from "lucide-react";

export default function WindowButtons() {
    const css = "w-3 h-3 rounded-full flex items-center justify-center";
    return (
        <div className="flex gap-2 w-20">
            <div className={`${css} bg-red-500`}><X className="size-2.5 stroke-3 text-red-800" /></div>
            <div className={`${css} bg-yellow-500`}><Minus className="size-2.5 stroke-3 text-yellow-800" /></div>
            <div className={`${css} bg-green-500`}><ChevronsLeftRight className="size-2.5 stroke-3 text-green-800 rotate-45" /></div>
        </div>
    )
}
